import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { Router, RouterModule } from '@angular/router';
import { ApiRequestService, GoogleTagManagerService, Material, ProductPreviewComponent, TranslationPipe } from '@prekog/common-ui';
import { PublicationService } from '../shared/publication.service';

interface AllProductsResponse {
    productList?: Material[];
}

@Component({
    selector: 'pf-all-products',
    templateUrl: './all-products.component.html',
    styleUrls: ['./all-products.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        MatIconModule,
        MatSelectModule,
        MatFormFieldModule,
        TranslationPipe,
        FormsModule,
        RouterModule,
        ProductPreviewComponent
    ]
})
export class AllProductsComponent implements OnInit {
    filteredPublication: Material[] = [];
    getAllProductsUrl = '/store/get-products';
    allProducts: Material[] = [];

    storeBaseUrl = '';

    private _listFilter = '';

    get listFilter(): string {
        return this._listFilter;
    }

    set listFilter(value: string) {
        this._listFilter = value;
        this.filteredPublication = this.performFilter(value);
    }

    constructor(
        private _publicationService: PublicationService,
        public router: Router,
        private _apiRequestService: ApiRequestService,
        @Inject('STORE_BACKEND_URL') private _storeBaseUrl: string,
        private _googleTagManagerService: GoogleTagManagerService
    ) {
        this.storeBaseUrl = _storeBaseUrl;
    }

    ngOnInit(): void {
        this.getProducts();
    }

    getProducts(): void {
        this._apiRequestService
            .sendRequest<{}, AllProductsResponse>(this.storeBaseUrl, {}, true, this.getAllProductsUrl)
            .subscribe((response) => {
                this.allProducts = (response.productList as Material[]) || [];
                this.allProducts.forEach((product) => {
                    if (product.webshopPriceActive) {
                        product.oldPrice = product.originalPrice;
                        product.originalPrice = product.webshopPrice;
                        if (product.discountLimitedUntil === null) {
                            product.typeOfPrice = 'Kiadói ár:';
                        } else {
                            product.typeOfPrice = 'Kötött ár:';
                        }
                    } else if (product.discountPriceActive) {
                        product.oldPrice = product.originalPrice;
                        product.originalPrice = product.discountPrice;
                        product.typeOfPrice = 'Akciós ár:';
                    } else if (product.hasPreorder) {
                        product.typeOfPrice = 'Előrendelési ár:';
                        product.oldPrice = product.originalPrice;
                        product.originalPrice = product.preorderPrice;
                    } else {
                        if (product.discountLimitedUntil === null) {
                            product.typeOfPrice = 'Ár:';
                        } else {
                            product.typeOfPrice = 'Kötött ár:';
                        }
                    }
                });

                this.filteredPublication = this.allProducts;
                this._googleTagManagerService.viewProductItemList(this.allProducts);
            });
    }

    performFilter(filterBy: string): Material[] {
        filterBy = filterBy.toLocaleLowerCase();
        return this.allProducts.filter(
            (publication: Material) =>
                publication.title?.toLocaleLowerCase().includes(filterBy) || publication.author?.toLocaleLowerCase().includes(filterBy)
        );
    }

    addToCart(material: Material): void {
        if (!sessionStorage.getItem('token') && material.hasPreorder) {
            sessionStorage.setItem('material', JSON.stringify(material));
            this._publicationService.openLogin();
        } else {
            this._publicationService.addToCart(material);
        }
    }

    orderbyAscPrice(): void {
        this.filteredPublication = this.filteredPublication.sort((a, b) => a.originalPrice! - b.originalPrice!);
    }

    orderbyDescPrice(): void {
        this.filteredPublication = this.filteredPublication.sort((a, b) => b.originalPrice! - a.originalPrice!);
    }

    orderbyTitleAbc(): void {
        this.filteredPublication = this.filteredPublication.sort((a, b) => a.title!.localeCompare(b.title!));
    }

    orderByNewest(): void {
        this.filteredPublication = this.filteredPublication.sort((a, b) => b.id! - a.id!);
    }
}
